import { Instance } from 'mobx-state-tree';
import React from 'react';
import { PharmacyDetails } from '../../../../store/models';

interface PharmacyPreferenceNoDutyDayForCalendarProps {
  pharmacyDetails: Instance<typeof PharmacyDetails>;
  getGroupName?: (pharmacyDetails: Instance<typeof PharmacyDetails>) => string;
  getPrefDayDutyText: (pharmacyDetails: Instance<typeof PharmacyDetails>) => string;
  showDetails?: boolean;
  emailAddress?: string;
}

export const PharmacyPreferenceNoDutyDayForCalendar = ({
  pharmacyDetails,
  getGroupName,
  getPrefDayDutyText,
  showDetails,
  emailAddress,
}: PharmacyPreferenceNoDutyDayForCalendarProps) => {
  return (
    <span style={{ alignContent: 'center', marginLeft: '20px' }}>
      <b>
        {showDetails ? (
          <span>
            {' '}
            ({pharmacyDetails.level})&nbsp;-&nbsp;(
            {getGroupName && getGroupName(pharmacyDetails)}
            )&nbsp;-&nbsp;&nbsp;{pharmacyDetails.apbNumber}&nbsp;-&nbsp;
            {pharmacyDetails.name}
            &nbsp;-&nbsp;{pharmacyDetails.address},&nbsp;
            {pharmacyDetails.zipCode}&nbsp;
            {pharmacyDetails.city}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        ) : (
          <></>
        )}
        {emailAddress ? (
          <span>
            <a href={'mailto:' + emailAddress + '?subject=Pharmagarde - Message du Secrétariat de garde'}>
              {emailAddress}
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        ) : (
          <></>
        )}
        {getPrefDayDutyText(pharmacyDetails)}
      </b>
    </span>
  );
};
